import posthog from "posthog-js";

/**
 * Single decision point for whether PostHog session replay may run.
 *
 * Two independent signals gate it and both have to allow recording: the
 * visitor's cookie consent, and the route (auth screens are never recorded).
 * They are combined here rather than each calling PostHog directly, so that one
 * signal turning on cannot silently override the other.
 *
 * `posthog.init` starts with `disable_session_recording: true`, so recording
 * stays off until consent is confirmed — never the other way round.
 */
let consentGranted = false;
let routeBlocked = false;

const apply = () => {
  if (!process.env.NEXT_PUBLIC_POSTHOG_TOKEN) {
    return;
  }

  if (consentGranted && !routeBlocked) {
    posthog.startSessionRecording();
    return;
  }

  posthog.stopSessionRecording();
};

/** Cookie consent for the statistics category, from Cookiebot. */
export const setSessionRecordingConsent = (granted: boolean) => {
  consentGranted = granted;
  apply();
};

/** Set while a route that must never be recorded is mounted. */
export const setSessionRecordingRouteBlocked = (blocked: boolean) => {
  routeBlocked = blocked;
  apply();
};
